// extracted by mini-css-extract-plugin
export var loadingSpinner = "_3v-1";
export var standaloneTable = "_3v-0";